import React from 'react';
import { Instagram, Facebook } from 'lucide-react';
export function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-brand-charcoal text-white py-16" data-id="element-76">
      <div className="container mx-auto px-4 md:px-6 flex flex-col items-center text-center" data-id="element-77">
        <a href="#home" className="mb-10 inline-block" data-id="element-78">
          <img src="https://cdn.magicpatterns.com/uploads/5SrFpE89xbZUevWfBMF76a/kbella_logo.webp" alt="K'Bella Spa & Wellness" className="h-16 md:h-20 brightness-0 invert opacity-90 hover:opacity-100 transition-opacity" data-id="element-79" />
        </a>

        <nav className="mb-10 w-full" data-id="element-80">
          <ul className="flex flex-col md:flex-row items-center justify-center gap-6 md:gap-10" data-id="element-81">
            <li data-id="element-82">
              <a href="#home" className="text-white/80 hover:text-brand-teal transition-colors uppercase tracking-wider text-sm font-semibold min-h-[44px] flex items-center" data-id="element-83">
                Home
              </a>
            </li>
            <li data-id="element-84">
              <a href="#services" className="text-white/80 hover:text-brand-teal transition-colors uppercase tracking-wider text-sm font-semibold min-h-[44px] flex items-center" data-id="element-85">
                Services
              </a>
            </li>
            <li data-id="element-86">
              <a href="#contact" className="text-white/80 hover:text-brand-teal transition-colors uppercase tracking-wider text-sm font-semibold min-h-[44px] flex items-center" data-id="element-87">
                Contact
              </a>
            </li>
            <li data-id="element-88">
              <a href="#" className="text-white/80 hover:text-brand-teal transition-colors uppercase tracking-wider text-sm font-semibold min-h-[44px] flex items-center" data-id="element-89">
                Store
              </a>
            </li>
            <li data-id="element-90">
              <a href="#" className="text-white/80 hover:text-brand-teal transition-colors uppercase tracking-wider text-sm font-semibold min-h-[44px] flex items-center" data-id="element-91">
                Gift Certificates
              </a>
            </li>
          </ul>
        </nav>

        <div className="flex gap-6 mb-12" data-id="element-92">
          <a href="#" className="w-12 h-12 rounded-full border border-white/20 flex items-center justify-center text-white/80 hover:bg-brand-teal hover:text-white hover:border-brand-teal transition-all" aria-label="Instagram" data-id="element-93">
            <Instagram className="w-5 h-5" data-id="element-94" />
          </a>
          <a href="#" className="w-12 h-12 rounded-full border border-white/20 flex items-center justify-center text-white/80 hover:bg-brand-teal hover:text-white hover:border-brand-teal transition-all" aria-label="Facebook" data-id="element-95">
            <Facebook className="w-5 h-5" data-id="element-96" />
          </a>
        </div>

        <div className="w-full max-w-md h-px bg-white/10 mb-8" data-id="element-97"></div>

        <p className="text-white/50 text-sm" data-id="element-98">
          &copy; {currentYear} K'Bella Spa & Wellness — All Rights Reserved.
        </p>
      </div>
    </footer>;
}